import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab, Button, Spinner } from "react-bootstrap";
import { Bell, Mail, User, Lock, Shield } from "lucide-react";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import "../../../assets/css/seller/SettingInSeller/SettingInSeller.css";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";

const SettingInSeller = () => {
  const { baseUrl, loggedInSeller } = useContext(AppContext);
  const authHeader = () => {
    const token = localStorage.getItem("sellerToken");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };
  const [idToUpdate, setIdToUpdate] = useState("");
  const [key, setKey] = useState("profile");
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  // ================= KYC STATES =================
  const [kycShopName, setKycShopName] = useState("");
  const [kycAddress, setKycAddress] = useState("");
  const [kycCnic, setKycCnic] = useState("");
  const [kycRegNo, setKycRegNo] = useState("");
  const [kycDocument, setKycDocument] = useState(null);
  const [kyc_status, setKyc_Status] = useState("");
  const [kycLoading, setKycLoading] = useState(false);

  const [notificationSettings, setNotificationSettings] = useState({
    appNotification: true,
    emailNotification: false,
  });

  const toggleNotification = (field) => {
    const updated = {
      ...notificationSettings,
      [field]: !notificationSettings[field],
    };
    setNotificationSettings(updated);

    const formData = new FormData();
    formData.append("id", idToUpdate);
    formData.append("inAppNotif", updated.appNotification ? 1 : 0);
    formData.append("eamilNotif", updated.emailNotification ? 1 : 0);

    axios
      .post(`${baseUrl}/seller/setting/updateNotification`, formData, {
        headers: authHeader(),
      })
      .catch((error) => console.log(error.response?.data));
  };

  const viewSellerProfile = () => {
    axios
      .get(`${baseUrl}/seller/setting/viewSellerprofile`, {
        headers: authHeader(),
      })
      .then((response) => {
        const data = response.data.admin;
        resetForm();

        setIdToUpdate(data.id);

        setFullname(data.fullName);
        setEmail(data.email);
        setPhone(data.phone);

        setKycShopName(data.shopname || "");
        setKycAddress(data.businessAddress || "");
        setKycCnic(data.cnicNumber || "");
        setKycRegNo(data.businessRegistrationNo || "");
        setKyc_Status(data.kyc_status || "not_submitted");

        setNotificationSettings({
          appNotification: data.inAppNotif === 1,
          emailNotification: data.eamilNotif === 1,
        });
      })
      .catch((error) => {
        console.log(error.response?.data);
      });
  };

  const updateProfile = () => {
    if (newPassword && newPassword !== confirmPassword) {
      Swal.fire({ icon: "error", title: "Oops", text: "Password not matched" });
      return;
    }

    setUpdateProfileLoading(true);

    const formData = new FormData();
    formData.append("id", idToUpdate);
    formData.append("fullName", fullname);
    formData.append("phone", phone);

    axios
      .post(`${baseUrl}/seller/setting/updateProfile`, formData, {
        headers: { "Content-Type": "multipart/form-data", ...authHeader() },
      })
      .then((res) => {
        setUpdateProfileLoading(false);
        viewSellerProfile();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile updated successfully",
        });
      })
      .catch((error) => {
        console.log(error.response?.data);
        setUpdateProfileLoading(false);
      });
  };

  const changePassword = () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({ icon: "error", title: "Oops", text: "Password not matched" });
      return;
    }

    setChangePasswordLoading(true);

    const formData = new FormData();
    formData.append("id", idToUpdate);
    formData.append("current_password", currentPassword);
    formData.append("new_password", newPassword);
    formData.append("confirm_password", confirmPassword);

    axios
      .post(`${baseUrl}/seller/setting/changePassword`, formData, {
        headers: authHeader(),
      })
      .then((res) => {
        setChangePasswordLoading(false);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
      })
      .catch((error) => {
        console.log(error.response?.data);
        setChangePasswordLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: error.response?.data?.message,
        });
      });
  };

  const submitKyc = () => {
    console.log("sellerToken:", localStorage.getItem("sellerToken"));
    console.log("token:", localStorage.getItem("token"));
    console.log(
      "loggedInSeller:",
      JSON.parse(localStorage.getItem("loggedInSeller")),
    );
    if (!kycShopName || !kycAddress || !kycCnic) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Please fill all required KYC fields",
      });
      return;
    }

    setKycLoading(true);

    const formData = new FormData();
    formData.append("id", idToUpdate);
    formData.append("shopname", kycShopName);
    formData.append("businessAddress", kycAddress); // ⚠️ neeche note dekho
    formData.append("cnicNumber", kycCnic);
    formData.append("businessRegistrationNo", kycRegNo);
    if (kycDocument) {
      formData.append("kyc_document", kycDocument);
    }

    axios
      .post(`${baseUrl}/seller/setting/submitKyc`, formData, {
        headers: {
          ...authHeader(),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setKycLoading(false);
        if (res.data.success) {
          setKyc_Status("pending");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
          });
        } else {
          Swal.fire({ icon: "error", title: "Oops", text: res.data.message });
        }
      })
      .catch((error) => {
        setKycLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: error.response?.data?.message || "Something went wrong",
        });
      });
  };

  // ---------------- RESET FORM ----------------
  const resetForm = () => {
    setFullname("");
    setEmail("");
    setPhone("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setIdToUpdate("");
  };
  useEffect(() => {
    console.log("useEffect called from the profile screen", loggedInSeller);
    viewSellerProfile();

    // setFullname(loggedInSeller.fullName);
    // setEmail(loggedInSeller.email);
    // setPhone(loggedInSeller.phone);
  }, []);

  return (
    <SellerMasterLayout>
      <div className="settings-wrapper">
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="settings-tabs"
        >
          {/* ================= PROFILE TAB ================= */}
          <Tab
            eventKey="profile"
            title={
              <span className="tab-title">
                <User size={16} /> Profile
              </span>
            }
          >
            <div className="settings-card">
              <h5>Profile Information</h5>

              <div className="settings-grid">
                <input
                  type="text"
                  placeholder="Full Name"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  disabled={true}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              {/* ✅ Update Profile Button */}
              <div className="text-end mt-4">
                <Button onClick={updateProfile} disabled={updateProfileLoading}>
                  {updateProfileLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Update Profile"
                  )}
                </Button>
              </div>
            </div>
          </Tab>

          {/* ================= PASSWORD TAB ================= */}
          <Tab
            eventKey="password"
            title={
              <span className="tab-title">
                <Lock size={16} /> Password
              </span>
            }
          >
            <div className="settings-card">
              <h5>Reset Password</h5>

              <div className="settings-grid">
                <input
                  type="password"
                  placeholder="Current Password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              {/* ✅ Reset Password Button */}
              <div className="text-end mt-4">
                <Button
                  variant="danger"
                  onClick={changePassword}
                  disabled={changePasswordLoading}
                >
                  {changePasswordLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Reset Password"
                  )}
                </Button>
              </div>
            </div>
          </Tab>

          {/* ================= KYC TAB ================= */}
          <Tab
            eventKey="kyc"
            title={
              <span className="tab-title">
                <Shield size={16} /> KYC
              </span>
            }
          >
            <div className="settings-card">
              {/* Header */}
              <div className="kyc-header">
                <div>
                  <h5>KYC Verification</h5>
                  <p>Verify your identity and shop</p>
                </div>

                <span className={`kyc_status ${kyc_status}`}>
                  {kyc_status === "not_submitted" && "Not Submitted"}
                  {kyc_status === "pending" && "Pending"}
                  {kyc_status === "approved" && "Approved"}
                  {kyc_status === "rejected" && "Rejected"}
                </span>
              </div>

              {/* PENDING — form hidden, status message */}
              {kyc_status === "pending" && (
                <div className="kyc-info-box kyc-pending-box">
                  <p>
                    Your KYC request has been submitted and is currently under
                    review. We'll notify you once it's processed.
                  </p>
                </div>
              )}

              {/* APPROVED — form hidden, success message */}
              {kyc_status === "approved" && (
                <div className="kyc-info-box kyc-approved-box">
                  <p>✅ Your KYC has been approved. Your shop is verified.</p>
                </div>
              )}

              {/* REJECTED / NOT_SUBMITTED — form visible */}
              {/* REJECTED / NOT_SUBMITTED / EMPTY — form visible */}
              {(!kyc_status ||
                kyc_status === "not_submitted" ||
                kyc_status === "rejected") && (
                <>
                  {/* Rejected Message */}
                  {kyc_status === "rejected" && (
                    <div className="kyc-info-box kyc-rejected-box">
                      <p>
                        Your previous KYC request was rejected. Please review
                        your details and resubmit.
                      </p>
                    </div>
                  )}

                  {/* Requirements */}
                  <div className="kyc-requirements">
                    <h6>Document Requirements</h6>
                    <ul>
                      <li>CNIC Front & Back</li>
                      <li>Shop License</li>
                      <li>Tax ID / NTN Certificate</li>
                    </ul>
                  </div>

                  {/* KYC Form */}
                  <div className="settings-grid">
                    <input
                      type="text"
                      placeholder="Shop Name"
                      value={kycShopName}
                      onChange={(e) => setKycShopName(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="Shop Address"
                      value={kycAddress}
                      onChange={(e) => setKycAddress(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="CNIC Number"
                      value={kycCnic}
                      onChange={(e) => setKycCnic(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="Business Registration No. (Optional)"
                      value={kycRegNo}
                      onChange={(e) => setKycRegNo(e.target.value)}
                    />
                  </div>

                  {/* Upload */}
                  <div className="kyc-upload">
                    <p>Click or drag to upload your document</p>
                    <small>PDF, JPG or PNG (Max 5MB)</small>

                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) => setKycDocument(e.target.files[0])}
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="text-end mt-4">
                    <Button onClick={submitKyc} disabled={kycLoading}>
                      {kycLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Submit KYC Request"
                      )}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Tab>

          {/* ================= NOTIFICATIONS TAB ================= */}
          <Tab
            eventKey="notifications"
            title={
              <span className="tab-title">
                <Bell size={16} /> Notifications
              </span>
            }
          >
            <div className="settings-card">
              <h5>Notification Settings</h5>

              <div className="settings-row">
                <div className="setting-info">
                  <Bell size={18} />
                  <span>App Notification</span>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={notificationSettings.appNotification}
                    onChange={() => toggleNotification("appNotification")}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              <div className="settings-row">
                <div className="setting-info">
                  <Mail size={18} />
                  <span>Email Notification</span>
                </div>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={notificationSettings.emailNotification}
                    onChange={() => toggleNotification("emailNotification")}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </SellerMasterLayout>
  );
};

export default SettingInSeller;
